export default __webpack_public_path__ + "static/media/InsuranceConfig.a588565b.svg";